<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="720" persistent>
      <v-card class="pr-card">
        <v-card-title class="pr-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-file-document-edit</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Pre‑inscribir prospecto</div>
              <div class="text-body-2 white--text">
                Completa los datos y adjunta el comprobante de pago
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-combobox
                v-model="new_preregistro.tipo_inscripcion"
                :items="tipos"
                label="Tipo de inscripcion"
                placeholder="Seleccione..."
                outlined
                dense
                prepend-inner-icon="mdi-form-select"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                v-model="new_preregistro.plan_pago"
                :items="planes"
                label="Plan de pagos"
                placeholder="Seleccione..."
                outlined
                dense
                prepend-inner-icon="mdi-calendar-check"
              />
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <div class="text-subtitle-2 mb-2">Documentos</div>
          <v-file-input
            v-model="archivo_comprobante"
            label="Comprobante de pago *"
            accept="image/*,application/pdf"
            outlined
            dense
            hide-details
            prepend-icon="mdi-receipt"
            @change="cargarArchivo('comprobante_pago', $event)"
          />

          <v-file-input
            v-model="archivo_carnet"
            label="Carnet de identidad (opcional)"
            accept="image/*,application/pdf"
            outlined
            dense
            hide-details
            class="mt-3"
            prepend-icon="mdi-card-account-details"
            @change="cargarArchivo('carnet_identidad', $event)"
          />

          <v-alert type="info" border="left" colored-border class="mt-4">
            Esta solicitud debe ser revisada por la contadora de sede del programa. Luego de validar la informacion,
            se podra inscribir en el programa.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
          <v-btn color="green" class="white--text" :loading="loading" @click="enviar()">
            <v-icon left small>mdi-check</v-icon>
            Registrar solicitud
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { createPreRegistro, tipos_inscripcion, plan_pagos } from './utils';
  export default {
    components: {},
    data() {
      return {
        loading: true,
        dialog: false,
        contacto: {},
        estado: 'PENDIENTE_VALIDACION',
        tipos: tipos_inscripcion(),
        planes: plan_pagos(),
        new_preregistro: {},
        archivo_comprobante: null,
        archivo_carnet: null,
      };
    },
    computed: {},
    watch: {},
    methods: {
      async openmodal(row) {
        this.filtroprograma = '';
        this.contacto = row;
        this.loading = false;
        this.dialog = true;
        this.archivo_comprobante = null;
        this.archivo_carnet = null;
        this.new_preregistro = { documentos: [] };
        this.new_preregistro.prospecto_id = row.id;
        this.new_preregistro.estado = this.estado;
        this.new_preregistro.tipo_inscripcion = null;
        this.new_preregistro.plan_pago = null;
        this.new_preregistro.fecha_inscripcion = '2026-03-05T20:15:00Z';
      },

      cargarArchivo(campo, file) {
        let tipo = '';
        if (campo == 'comprobante_pago') tipo = 'COMPROBANTE_PAGO';
        if (campo == 'carnet_identidad') tipo = 'CARNET_IDENTIDAD';
        const ex = this.new_preregistro.documentos.find((x) => x.tipo == tipo);

        if (!file) {
          this.new_preregistro.documentos = this.new_preregistro.documentos.filter(x=>x.tipo!=tipo);
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          if (ex) {
            ex.base64 = e.target.result;
          } else {
            const d = { tipo: tipo, base64: e.target.result, nombre_archivo: tipo };
            this.new_preregistro.documentos.push(d);
          }
        };
        reader.readAsDataURL(file);
      },
      cerrar() {
        this.dialog = false;
      },

      async enviar() {
        if (!this.new_preregistro.tipo_inscripcion) {
          this.$root.$notify.show('seleccione un tipo de inscripcion', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_preregistro.plan_pago) {
          this.$root.$notify.show('seleccione un plan de pagos', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_preregistro.documentos.find((x) => x.tipo == 'COMPROBANTE_PAGO')) {
          this.$root.$notify.show('suba el comprobante de pago', { color: 'red', x: 'right' });
          return;
        }
        this.loading = true;
        const res = await createPreRegistro(this.new_preregistro);
        this.loading = false;
        window.console.log('res', res);
        if(res && res.id){
          this.$root.$notify.show('Listo, la contadora debe verificar la informacion enviada para proceder a la inscripcion', { color: 'green', x: 'right' });
          this.cerrar();
        }else if(res && res.error){
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }
      },
    },
    mounted() {},
  };
</script>

<style scoped>
.pr-card {
  border-radius: 14px;
  overflow: hidden;
}
.pr-hero {
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
</style>
